function getMessageBannerSelector () {
  return state => state && state.banner.message
}

export default getMessageBannerSelector
